import { t } from "i18next";
import * as yup from "yup";
import ajaxClient from "../../../js/common/AjaxClient";
import eshopFormValidationService from "../general/EshopFormValidationService";
import { Validation } from "../localization/localeValidation";
import elementService from "@/common/ElementService";

interface SaveProductQuestionMessageResponse {
    html: string;
}

const productQuestionSchema = yup.object({
    name: yup.string().trim()
        .nullable(),
    email: yup.string().trim()
        .lowercase()
        .matches(Validation.EmailRegEx, t("header:validEmail"))
        .required("E‑mail je povinný"),
    message: yup.string().trim()
        .min(5, "Zadejte Váš dotaz (min. 5 znaků)")
        .required("Dotaz je povinný"),
    productId: yup.number()
        .required()
        .integer()
        .positive(),
    packageId: yup.number()
        .required()
        .integer()
        .positive(),
}).required();
type ProductQuestionFormSchema = yup.InferType<typeof productQuestionSchema>;

export default new class ProductQuestionFormService {
    public init(): void {
        this.initFormsValidation();
    }

    private initFormsValidation(): void {
        const productQuestionForm = elementService.querySelector<HTMLFormElement>("#js-product-question-form");

        eshopFormValidationService.init<ProductQuestionFormSchema>(productQuestionForm, productQuestionSchema, {
            onValidSubmit: (): void => {
                const control2Input = elementService.elementQuerySelector<HTMLInputElement>(productQuestionForm, "input[name='control2']");

                control2Input.value = "val2";

                void this.submitProductQuestionForm(productQuestionForm);
            },
        });
    }

    private async submitProductQuestionForm(productQuestionForm: HTMLFormElement): Promise<void> {
        const response = await ajaxClient.post<SaveProductQuestionMessageResponse>(
            "/Product/jsSaveProductQuestionMessage",
            new FormData(productQuestionForm),
        );

        elementService.querySelector<HTMLDivElement>("#js-question-form-container").innerHTML = response.html;
    }
}();
